import { render, staticRenderFns } from "./ExternalA.vue?vue&type=template&id=19da38e4"
import script from "./ExternalA.vue?vue&type=script&lang=js"
export * from "./ExternalA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports